<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4">
        <div data-v-13a23bd0="" v-if="backgroundViewMode && loginData.backgroundImage !== null">
          <label class="vs-input--label"> Imagem de fundo </label>
          <div data-v-13a23bd0="" class="con-upload">
            <div class="con-img-upload">
              <div class="img-upload">
                <button type="button" class="btn-x-file" @click="closeImageBackground"><i translate="translate" class="material-icons notranslate">clear</i></button>
                <img :src="loginData.backgroundImage" style="max-width: 100%; max-height: none;" @click="clickImageBackground(loginData.backgroundImage)">
              </div>
              <div class="con-input-upload disabled-upload">
                <input type="file" accept="image/*" disabled="disabled"><span class="text-input">Upload File</span>
                <span class="input-progress" style="width: 0%;"></span>
                <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="!backgroundViewMode && loginData.backgroundImage === null" >
          <label class="vs-input--label">Imagem de fundo</label>
          <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUpload($event, 1)" />
        </div>
      </div>
      <div class="vx-col w-full md:w-1/4">
        <div data-v-13a23bd0="" v-if="cardImageViewMode && loginData.cardImage !== null">
          <label class="vs-input--label"> Imagem do Card </label>
          <div data-v-13a23bd0="" class="con-upload">
            <div class="con-img-upload">
              <div class="img-upload">
                <button type="button" class="btn-x-file" @click="closeImageCardImage"><i translate="translate" class="material-icons notranslate">clear</i></button>
                <img :src="loginData.cardImage" style="max-width: 100%; max-height: none;" @click="clickImageCardImage(loginData.cardImage)">
              </div>
              <div class="con-input-upload disabled-upload">
                <input type="file" accept="image/*" disabled="disabled"><span class="text-input">Upload File</span>
                <span class="input-progress" style="width: 0%;"></span>
                <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="!cardImageViewMode && loginData.cardImage === null">
          <label class="vs-input--label">Imagem do Card</label>
          <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUpload($event, 2)" />
        </div>
      </div>
      <div class="vx-col w-full md:w-1/4">
        <div data-v-13a23bd0="" v-if="cardLogoViewMode && loginData.cardLogo !== null">
          <label class="vs-input--label"> Logo do Card </label>
          <div data-v-13a23bd0="" class="con-upload">
            <div class="con-img-upload">
              <div class="img-upload">
                <button type="button" class="btn-x-file" @click="closeImageCardLogo"><i translate="translate" class="material-icons notranslate">clear</i></button>
                <img :src="loginData.cardLogo" style="max-width: 100%; max-height: none;" @click="clickImageCardLogo(loginData.cardLogo)">
              </div>
              <div class="con-input-upload disabled-upload">
                <input type="file" accept="image/*" disabled="disabled"><span class="text-input">Upload File</span>
                <span class="input-progress" style="width: 0%;"></span>
                <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
              </div>
            </div>
          </div>
        </div>

        <div
          v-else-if="!cardLogoViewMode && loginData.cardLogo === null"
        >
          <label class="vs-input--label">Logo do Card</label>
          <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUpload($event, 3)" />
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3">

        <!-- Col Content -->
        <div>
          <vs-input class="w-full mt-4" label="Título da aba do navegador" v-model="loginData.tabName" @input="setTabName" name="address_line_1" />

          <vs-input class="w-full mt-4" label="Label do campo usuário" v-model="loginData.usernameLabel" @input="setUsernameLabel" name="address_line_2"/>

          <vs-input class="w-full mt-4" label='Label do botão "Esqueci minha senha"' v-model="loginData.forgotLabel" @input="setForgotLabel" name="address_line_2"/>

          <vs-input class="w-full mt-4" label="Label do botão no formulário de resetar senha" v-model="loginData.forgotPasswordButtonLabel" @input="setForgotPasswordButtonLabel" name="address_line_2"/>
        </div>

      </div>

      <!-- Address Col -->
      <div class="vx-col w-full md:w-1/3">

        <!-- Col Content -->
        <div>
          <vs-input class="w-full mt-4" label="Título do card" v-model="loginData.title" @input="setTitle" name="address_line_1" />

          <vs-input class="w-full mt-4" label="Label do campo senha" v-model="loginData.passwordLabel" @input="setPasswordLabel" name="address_line_2"/>

          <vs-input class="w-full mt-4" label="Título do formulário de resetar senha" v-model="loginData.forgotPasswordTitle" @input="setForgotPasswordTitle" name="address_line_2"/>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/3">

          <!-- Col Content -->
          <div>
            <vs-input class="w-full mt-4" label="Legenda do card" v-model="loginData.subtitle" @input="setSubtitle" name="address_line_1" />

            <vs-input class="w-full mt-4" label="Label do botão enviar" v-model="loginData.submitLabel" @input="setSubmitLabel" name="address_line_2"/>

            <vs-input class="w-full mt-4" label="Label do campo email no formulário de resetar senha" v-model="loginData.forgotPasswordEmailLabel" @input="setForgotPasswordEmailLabel" name="address_line_2"/>
          </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Salvar Alterações</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Resetar</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {

      backgroundViewMode: true,
      cardImageViewMode: true,
      cardLogoViewMode: true,

      loginData: {
        backgroundImage: '',
        cardImage: '',
        cardLogo: '',
        tabName: '',
        title: '',
        subtitle: '',
        usernameLabel: '',
        passwordLabel: '',
        submitLabel: '',
        forgotLabel: '',
        forgotPasswordTitle: '',
        forgotPasswordEmailLabel: '',
        forgotPasswordButtonLabel: ''
      },

      mobile: {
        get () {
          return this.$store.state.applicationManagement.userProfile.mobile
        }
      },

      data_local: null,

      local_language: [],

      all_options: [],

      // local_gender: this.$store.state.applicationManagement.userProfile.gender_id,

      local_contact: {
        get () {
          return ['email', 'message']
        },
        set (value) {

        }
      },

      langOptions: []
    }
  },
  created () {

    setTimeout(() => {
      this.loginData.backgroundImage = this.$store.state.applicationManagement.settings.background
      if(this.loginData.backgroundImage === null) {
        this.backgroundViewMode = false
      }
      this.loginData.cardImage = this.$store.state.applicationManagement.settings.cardLogo
      if(this.loginData.cardImage === null) {
        this.cardImageViewMode = false
      }
      this.loginData.cardLogo = this.$store.state.applicationManagement.settings.logo
      if(this.loginData.cardLogo === null) {
        this.cardLogoViewMode = false
      }
      this.loginData.tabName = this.$store.state.applicationManagement.settings.tabTitle
      this.loginData.title = this.$store.state.applicationManagement.settings.title
      this.loginData.subtitle = this.$store.state.applicationManagement.settings.subtitle
      this.loginData.usernameLabel = this.$store.state.applicationManagement.settings.usernameLabel
      this.loginData.passwordLabel = this.$store.state.applicationManagement.settings.passwordLabel
      this.loginData.submitLabel = this.$store.state.applicationManagement.settings.submitButtonText
      this.loginData.forgotLabel = this.$store.state.applicationManagement.settings.forgotLabel
      this.loginData.forgotPasswordTitle = this.$store.state.applicationManagement.settings.forgotPasswordTitle
      this.loginData.forgotPasswordEmailLabel = this.$store.state.applicationManagement.settings.forgotPasswordEmailLabel
      this.loginData.forgotPasswordButtonLabel = this.$store.state.applicationManagement.settings.forgotPasswordButtonLabel

      console.log(this.loginData)
    }, 300)

    // const local_lang_options = this.$store.state.auth.languages

    // const selected_languages_id = []

    // for (const item of Object.values(local_lang_options)) {
    //   const obj = {label: item.name, value: item.id, hash: item.hash}
    //   this.langOptions.push(obj)
    //   this.all_options.push(obj)
    // }

    // // console.log(this.all_options)

    // const local_user_lang_options = this.$store.state.applicationManagement.userProfile.languages

    // for (const item of local_user_lang_options) {
    //   selected_languages_id.push(item.id)
    //   this.local_language.push({label: item.name, value: item.id, hash: item.hash})
    // }

    // this.langOptions = this.langOptions.filter(o => !selected_languages_id.includes(o.value))
  },
  computed: {
    validateForm () {

      const specialRegex = new RegExp('^[0-9a-zA-Z ãâáàéêè\b]+$')

      // if (!this.$store.state.applicationManagement.userProfile.name) {
      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'The name field in Account Tab is required',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // } else if (/\d/.test(this.$store.state.applicationManagement.userProfile.name)) {
      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'The name field may only contain alphabetic characters as well as spaces',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // } else if (!specialRegex.test(this.$store.state.applicationManagement.userProfile.name)) {
      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'The name field may contain alpha-numeric characters as well as dashes and underscores',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      return !this.errors.any()
    }
  },
  methods: {
    successUpload(event, type) {
      const responseData = JSON.parse(event.srcElement.response)

      if(type === 1) {
        // this.backgroundViewMode = !this.backgroundViewMode
        this.loginData.background = responseData.file_url
        this.$store.commit('applicationManagement/SET_BACKGROUND', responseData.file_url)
      } else if(type === 2) {
        this.cardImageViewMode = !this.cardImageViewMode
        this.loginData.cardImage = responseData.file_url
        this.$store.commit('applicationManagement/SET_CARD_IMAGE', responseData.file_url)
      } else {
        this.cardLogoViewMode = !this.cardLogoViewMode
        this.loginData.cardLogo = responseData.file_url
        this.$store.commit('applicationManagement/SET_CARD_LOGO', responseData.file_url)
      }
    },
    closeImageBackground() {
      this.backgroundViewMode = !this.backgroundViewMode
      this.loginData.backgroundImage = null
    },
    clickImageBackground(imagePayload) {
      const div = document.createElement('div')
      div.classList.add('view-upload')

      const img = document.createElement('img')

      img.setAttribute('src', imagePayload)

      div.appendChild(img)
      document.querySelector('body').prepend(div)
    },
    closeImageCardImage() {
      this.cardImageViewMode = !this.cardImageViewMode
      this.loginData.cardImage = null
    },
    clickImageCardImage(imagePayload) {
      const div = document.createElement('div')
      div.classList.add('view-upload')

      const img = document.createElement('img')

      img.setAttribute('src', imagePayload)

      div.appendChild(img)
      document.querySelector('body').prepend(div)
    },
    closeImageCardLogo() {
      this.cardLogoViewMode = !this.cardLogoViewMode
      this.loginData.cardLogo = null
    },
    clickImageCardLogo(imagePayload) {
      const div = document.createElement('div')
      div.classList.add('view-upload')

      const img = document.createElement('img')

      img.setAttribute('src', imagePayload)

      div.appendChild(img)
      document.querySelector('body').prepend(div)
    },
    setTabName (e) {
      this.$store.commit('applicationManagement/SET_TAB_NAME_LOGIN', e)
    },
    setUsernameLabel(e) {
      this.$store.commit('applicationManagement/SET_USERNAME_LABEL', e)
    },
    setForgotLabel(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_LABEL', e)
    },
    setForgotPasswordButtonLabel(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_PASSWORD_BUTTON_LABEL', e)
    },
    setTitle(e) {
      this.$store.commit('applicationManagement/SET_TITLE', e)
    },
    setPasswordLabel(e) {
      this.$store.commit('applicationManagement/SET_PASSWORD_LABEL', e)
    },
    setForgotPasswordTitle(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_PASSWORD_TITLE', e)
    },
    setSubtitle(e) {
      this.$store.commit('applicationManagement/SET_SUBTITLE', e)
    },
    setSubmitLabel(e) {
      this.$store.commit('applicationManagement/SET_SUBMIT_LABEL', e)
    },
    setForgotPasswordEmailLabel(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_PASSWORD_EMAIL_LABEL', e)
    },


    async fetch_user_data (userSession, appToken, apiUrl) {
      this.$vs.loading({type: 'default'})
      return await this.$store.dispatch('applicationManagement/fetchUserProfile', {userSession, appToken, apiUrl})
        .then((res) => {
          this.$vs.loading.close()
          this.$store.dispatch('applicationManagement/setUserProfile', res)
          this.user_data = res
        })
        .catch(err => {
          this.$vs.loading.close()
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    },

    save_changes () {

      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading({type: 'default'})

      this.$store.dispatch('applicationManagement/saveChanges', {userProfile: this.$store.state.applicationManagement.userProfile, apiUrl: this.$store.state.auth.api_url})
      .then(async (result) => {
        this.$vs.loading.close()

        this.$vs.notify({
          title: 'Operação Realizada!',
          text: `Dados alterados com sucesso!`,
          iconPack: 'feather',
          icon: 'icon-success-circle',
          color: 'success'
        })

      })
      .catch((err) => {
        // console.log(err)
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Erro',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
